require("!!/codebuild/output/src500842655/src/html5-media-tool-angular/node_modules/script-loader/addScript.js")(require("!!/codebuild/output/src500842655/src/html5-media-tool-angular/node_modules/raw-loader/index.js!/codebuild/output/src500842655/src/html5-media-tool-angular/node_modules/source-map-loader/index.js!/codebuild/output/src500842655/src/html5-media-tool-angular/src/assets/js/player.js"))


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/script-loader!/codebuild/output/src500842655/src/html5-media-tool-angular/src/assets/js/player.js
// module id = ../../../../script-loader/index.js!../../../../../src/assets/js/player.js
// module chunks = 3